import React, {Component} from 'react';
import {Menu} from 'semantic-ui-react';
import {map} from 'lodash';
import References from './References';
import Subcontract from './Subcontract';
import Parts from './Parts';
import Work from './Work';

const types = {
  'work': 'Trabajos',
  'parts': 'Partes',
  'subcontract': 'Subcontrato',
  'references': 'Referencia',
};

const DisplayContent = (props) => {
  const {id} = props;
  if (id === 'work') {
    return <Work {...props}/>;
  } else if (id === 'subcontract') {
    return <Subcontract {...props}/>;
  } else if (id === 'parts') {
    return <Parts {...props} />;
  }
  return <References {...props}/>;
};

class WarrantyContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {'activeItem': 'work'};
  }

  handleItemClick = (idx) => this.setState({'activeItem': idx})

  render() {
    const {activeItem} = this.state;
    const {handleChangeForm, jobs, files, subcontracts, parts, totalTwc, stateTwc, type, campaignFlag} = this.props;
    const total = type === 'EX' ? totalTwc * 0.2 : totalTwc;

    return (
      <div className='warranty-container-tabs'>
        <Menu attached='top' color='red' tabular>
          {map(types, (type, idx) => (
            <Menu.Item
              key={idx}
              name={type}
              active={activeItem === idx}
              onClick={() => this.handleItemClick(idx)}
            />
          ))}

          <Menu.Menu position='right'>
            <Menu.Item>
              <p className='warranty-label-total'>$ {total.toFixed(2)}</p>
            </Menu.Item>
          </Menu.Menu>
        </Menu>

        <div className='warranty-container-tabs-content'>
          <DisplayContent
            id={activeItem}
            {...this.props}
            handleChangeForm={handleChangeForm}
            jobs={jobs}
            files={files}
            subcontracts={subcontracts}
            parts={parts}
            stateTwc={stateTwc}
            campaignFlag={campaignFlag}
          />
        </div>
      </div>
    );
  }
}

export default WarrantyContainer;
